"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrpcWebError = exports.GrpcWebImpl = exports.TivServiceVerifyTivDesc = exports.TivServiceSetTivStatusDesc = exports.TivServiceGetTivStatusDesc = exports.TivServiceGetTivEligibilityDesc = exports.TivServiceGetTivByNonceDesc = exports.TivServiceLogTivTimedOutDesc = exports.TivServiceLogTivSentDesc = exports.TivServiceCreateTivNonceDesc = exports.TivServiceRecreateTivDesc = exports.TivServiceCreateTivDesc = exports.TivServiceLogTivNotificationDisplayedDesc = exports.TivServiceLogTivNotificationReceivedDesc = exports.TivServiceInAppApprovalDesc = exports.TivServiceTivDesc = exports.TivServiceDesc = exports.TivServiceClientImpl = exports.LogTivNotificationReceivedResponse = exports.LogTivNotificationReceivedRequest = exports.LogTivNotificationDisplayedResponse = exports.LogTivNotificationDisplayedRequest = exports.PlatformResponseData = exports.PlatformRequestData = exports.TransactionDwebData = exports.TivResponseDwebData = exports.InAppApprovalResponse = exports.InAppApprovalRequest = exports.TransactionDescription = exports.TivResponse = exports.TivRequest = exports.TivRequestInfo = exports.TivRequestDwebData = exports.DeviceData = exports.LocationData = exports.TivResponse_TivResponseStatus = exports.Channel = exports.Transaction = void 0;
/* eslint-disable */
const grpc_web_1 = require("@improbable-eng/grpc-web");
const create_tiv_1 = require("./api/create_tiv");
const recreate_tiv_1 = require("./api/recreate_tiv");
const create_tiv_nonce_1 = require("./api/create_tiv_nonce");
const log_tiv_sent_1 = require("./api/log_tiv_sent");
const log_tiv_timed_out_1 = require("./api/log_tiv_timed_out");
const get_tiv_by_nonce_1 = require("./api/get_tiv_by_nonce");
const get_tiv_eligibility_1 = require("./api/get_tiv_eligibility");
const get_tiv_status_1 = require("./api/get_tiv_status");
const set_tiv_status_1 = require("./api/set_tiv_status");
const verify_tiv_1 = require("./api/verify_tiv");
const browser_headers_1 = require("browser-headers");
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** Transaction needing verification */
var Transaction;
(function (Transaction) {
    /** UNSET - Default/unset */
    Transaction[Transaction["UNSET"] = 0] = "UNSET";
    /** ACCESS_WEB_CHAT - User trying to access chat on web */
    Transaction[Transaction["ACCESS_WEB_CHAT"] = 1] = "ACCESS_WEB_CHAT";
    /** ACCOUNTS_LOGIN - User tries to login to web via Accounts */
    Transaction[Transaction["ACCOUNTS_LOGIN"] = 2] = "ACCOUNTS_LOGIN";
    /** WEB_CHAT_LOGIN - User tries to login to web via web chat */
    Transaction[Transaction["WEB_CHAT_LOGIN"] = 3] = "WEB_CHAT_LOGIN";
    Transaction[Transaction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Transaction = exports.Transaction || (exports.Transaction = {}));
/** Channels for a TIV broadcast */
var Channel;
(function (Channel) {
    /** CHANNEL_UNSET - Default */
    Channel[Channel["CHANNEL_UNSET"] = 0] = "CHANNEL_UNSET";
    /** NUB - Nub/Duplex https://github.sc-corp.net/pages/scaddlive/adl_docs/tech/duplex_and_nub.html */
    Channel[Channel["NUB"] = 1] = "NUB";
    /** PUSH_NOTIFICATION - Push Notification */
    Channel[Channel["PUSH_NOTIFICATION"] = 2] = "PUSH_NOTIFICATION";
    Channel[Channel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Channel = exports.Channel || (exports.Channel = {}));
/** Response status of the transaction */
var TivResponse_TivResponseStatus;
(function (TivResponse_TivResponseStatus) {
    /** UNSET - Unset transaction status (default) */
    TivResponse_TivResponseStatus[TivResponse_TivResponseStatus["UNSET"] = 0] = "UNSET";
    /** APPROVED - Approved transaction */
    TivResponse_TivResponseStatus[TivResponse_TivResponseStatus["APPROVED"] = 1] = "APPROVED";
    /** DENIED - Explicitly denied transaction */
    TivResponse_TivResponseStatus[TivResponse_TivResponseStatus["DENIED"] = 2] = "DENIED";
    /** TIME_OUT - Transaction timed out */
    TivResponse_TivResponseStatus[TivResponse_TivResponseStatus["TIME_OUT"] = 3] = "TIME_OUT";
    /** INVALID_APP_VERSION - Invalid App version */
    TivResponse_TivResponseStatus[TivResponse_TivResponseStatus["INVALID_APP_VERSION"] = 4] = "INVALID_APP_VERSION";
    TivResponse_TivResponseStatus[TivResponse_TivResponseStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TivResponse_TivResponseStatus = exports.TivResponse_TivResponseStatus || (exports.TivResponse_TivResponseStatus = {}));
function createBaseLocationData() {
    return {
        city: "",
        country: "",
        ipAddress: "",
        longitude: 0,
        latitude: 0,
        asn: 0,
    };
}
exports.LocationData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.city !== "") {
            writer.uint32(10).string(message.city);
        }
        if (message.country !== "") {
            writer.uint32(18).string(message.country);
        }
        if (message.ipAddress !== "") {
            writer.uint32(26).string(message.ipAddress);
        }
        if (message.longitude !== 0) {
            writer.uint32(33).double(message.longitude);
        }
        if (message.latitude !== 0) {
            writer.uint32(41).double(message.latitude);
        }
        if (message.asn !== 0) {
            writer.uint32(48).uint32(message.asn);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLocationData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.city = reader.string();
                    break;
                case 2:
                    message.country = reader.string();
                    break;
                case 3:
                    message.ipAddress = reader.string();
                    break;
                case 4:
                    message.longitude = reader.double();
                    break;
                case 5:
                    message.latitude = reader.double();
                    break;
                case 6:
                    message.asn = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLocationData();
        message.city = object.city ?? "";
        message.country = object.country ?? "";
        message.ipAddress = object.ipAddress ?? "";
        message.longitude = object.longitude ?? 0;
        message.latitude = object.latitude ?? 0;
        message.asn = object.asn ?? 0;
        return message;
    },
};
function createBaseDeviceData() {
    return { deviceId: "", userAgent: "", device: "", os: "", browser: "" };
}
exports.DeviceData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.deviceId !== "") {
            writer.uint32(10).string(message.deviceId);
        }
        if (message.userAgent !== "") {
            writer.uint32(18).string(message.userAgent);
        }
        if (message.device !== "") {
            writer.uint32(26).string(message.device);
        }
        if (message.os !== "") {
            writer.uint32(34).string(message.os);
        }
        if (message.browser !== "") {
            writer.uint32(42).string(message.browser);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeviceData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.deviceId = reader.string();
                    break;
                case 2:
                    message.userAgent = reader.string();
                    break;
                case 3:
                    message.device = reader.string();
                    break;
                case 4:
                    message.os = reader.string();
                    break;
                case 5:
                    message.browser = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDeviceData();
        message.deviceId = object.deviceId ?? "";
        message.userAgent = object.userAgent ?? "";
        message.device = object.device ?? "";
        message.os = object.os ?? "";
        message.browser = object.browser ?? "";
        return message;
    },
};
function createBaseTivRequestDwebData() {
    return { data: new Uint8Array() };
}
exports.TivRequestDwebData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(10).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTivRequestDwebData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTivRequestDwebData();
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseTivRequestInfo() {
    return { dwebPlatformData: undefined };
}
exports.TivRequestInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.dwebPlatformData !== undefined) {
            exports.TivRequestDwebData.encode(message.dwebPlatformData, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTivRequestInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.dwebPlatformData = exports.TivRequestDwebData.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTivRequestInfo();
        message.dwebPlatformData =
            object.dwebPlatformData !== undefined && object.dwebPlatformData !== null
                ? exports.TivRequestDwebData.fromPartial(object.dwebPlatformData)
                : undefined;
        return message;
    },
};
function createBaseTivRequest() {
    return {
        transactionId: "",
        userId: "",
        sessionId: "",
        unixTimeOfRequest: "0",
        unixTimeOfExpiration: "0",
        locationData: undefined,
        deviceData: undefined,
        transaction: 0,
        unixCurrentServerTime: "0",
        broadcastId: "",
        transactionDescription: undefined,
        platformRequestData: undefined,
        channelId: "",
        channelIds: [],
    };
}
exports.TivRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.transactionId !== "") {
            writer.uint32(10).string(message.transactionId);
        }
        if (message.userId !== "") {
            writer.uint32(18).string(message.userId);
        }
        if (message.sessionId !== "") {
            writer.uint32(26).string(message.sessionId);
        }
        if (message.unixTimeOfRequest !== "0") {
            writer.uint32(32).uint64(message.unixTimeOfRequest);
        }
        if (message.unixTimeOfExpiration !== "0") {
            writer.uint32(40).uint64(message.unixTimeOfExpiration);
        }
        if (message.locationData !== undefined) {
            exports.LocationData.encode(message.locationData, writer.uint32(50).fork()).ldelim();
        }
        if (message.deviceData !== undefined) {
            exports.DeviceData.encode(message.deviceData, writer.uint32(58).fork()).ldelim();
        }
        if (message.transaction !== 0) {
            writer.uint32(64).int32(message.transaction);
        }
        if (message.unixCurrentServerTime !== "0") {
            writer.uint32(72).uint64(message.unixCurrentServerTime);
        }
        if (message.broadcastId !== "") {
            writer.uint32(82).string(message.broadcastId);
        }
        if (message.transactionDescription !== undefined) {
            exports.TransactionDescription.encode(message.transactionDescription, writer.uint32(90).fork()).ldelim();
        }
        if (message.platformRequestData !== undefined) {
            exports.PlatformRequestData.encode(message.platformRequestData, writer.uint32(98).fork()).ldelim();
        }
        if (message.channelId !== "") {
            writer.uint32(106).string(message.channelId);
        }
        for (const v of message.channelIds) {
            writer.uint32(114).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTivRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transactionId = reader.string();
                    break;
                case 2:
                    message.userId = reader.string();
                    break;
                case 3:
                    message.sessionId = reader.string();
                    break;
                case 4:
                    message.unixTimeOfRequest = longToString(reader.uint64());
                    break;
                case 5:
                    message.unixTimeOfExpiration = longToString(reader.uint64());
                    break;
                case 6:
                    message.locationData = exports.LocationData.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.deviceData = exports.DeviceData.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.transaction = reader.int32();
                    break;
                case 9:
                    message.unixCurrentServerTime = longToString(reader.uint64());
                    break;
                case 10:
                    message.broadcastId = reader.string();
                    break;
                case 11:
                    message.transactionDescription = exports.TransactionDescription.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.platformRequestData = exports.PlatformRequestData.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.channelId = reader.string();
                    break;
                case 14:
                    message.channelIds.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTivRequest();
        message.transactionId = object.transactionId ?? "";
        message.userId = object.userId ?? "";
        message.sessionId = object.sessionId ?? "";
        message.unixTimeOfRequest = object.unixTimeOfRequest ?? "0";
        message.unixTimeOfExpiration = object.unixTimeOfExpiration ?? "0";
        message.locationData =
            object.locationData !== undefined && object.locationData !== null
                ? exports.LocationData.fromPartial(object.locationData)
                : undefined;
        message.deviceData =
            object.deviceData !== undefined && object.deviceData !== null
                ? exports.DeviceData.fromPartial(object.deviceData)
                : undefined;
        message.transaction = object.transaction ?? 0;
        message.unixCurrentServerTime = object.unixCurrentServerTime ?? "0";
        message.broadcastId = object.broadcastId ?? "";
        message.transactionDescription =
            object.transactionDescription !== undefined &&
                object.transactionDescription !== null
                ? exports.TransactionDescription.fromPartial(object.transactionDescription)
                : undefined;
        message.platformRequestData =
            object.platformRequestData !== undefined &&
                object.platformRequestData !== null
                ? exports.PlatformRequestData.fromPartial(object.platformRequestData)
                : undefined;
        message.channelId = object.channelId ?? "";
        message.channelIds = object.channelIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseTivResponse() {
    return { transactionId: "", status: 0, platformResponseData: undefined };
}
exports.TivResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.transactionId !== "") {
            writer.uint32(10).string(message.transactionId);
        }
        if (message.status !== 0) {
            writer.uint32(16).int32(message.status);
        }
        if (message.platformResponseData !== undefined) {
            exports.PlatformResponseData.encode(message.platformResponseData, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTivResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transactionId = reader.string();
                    break;
                case 2:
                    message.status = reader.int32();
                    break;
                case 3:
                    message.platformResponseData = exports.PlatformResponseData.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTivResponse();
        message.transactionId = object.transactionId ?? "";
        message.status = object.status ?? 0;
        message.platformResponseData =
            object.platformResponseData !== undefined &&
                object.platformResponseData !== null
                ? exports.PlatformResponseData.fromPartial(object.platformResponseData)
                : undefined;
        return message;
    },
};
function createBaseTransactionDescription() {
    return { title: "", destination: "" };
}
exports.TransactionDescription = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.destination !== "") {
            writer.uint32(18).string(message.destination);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTransactionDescription();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.destination = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTransactionDescription();
        message.title = object.title ?? "";
        message.destination = object.destination ?? "";
        return message;
    },
};
function createBaseInAppApprovalRequest() {
    return { response: undefined, broadcastId: "" };
}
exports.InAppApprovalRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.response !== undefined) {
            exports.TivResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        if (message.broadcastId !== "") {
            writer.uint32(18).string(message.broadcastId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInAppApprovalRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = exports.TivResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.broadcastId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseInAppApprovalRequest();
        message.response =
            object.response !== undefined && object.response !== null
                ? exports.TivResponse.fromPartial(object.response)
                : undefined;
        message.broadcastId = object.broadcastId ?? "";
        return message;
    },
};
function createBaseInAppApprovalResponse() {
    return { response: undefined };
}
exports.InAppApprovalResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.response !== undefined) {
            exports.TivResponse.encode(message.response, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInAppApprovalResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.response = exports.TivResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseInAppApprovalResponse();
        message.response =
            object.response !== undefined && object.response !== null
                ? exports.TivResponse.fromPartial(object.response)
                : undefined;
        return message;
    },
};
function createBaseTivResponseDwebData() {
    return { data: new Uint8Array() };
}
exports.TivResponseDwebData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(10).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTivResponseDwebData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTivResponseDwebData();
        message.data = object.data ?? new Uint8Array();
        return message;
    },
};
function createBaseTransactionDwebData() {
    return {
        transactionId: "",
        broadcastId: "",
        authnSessionId: "",
        dwebData: undefined,
    };
}
exports.TransactionDwebData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.transactionId !== "") {
            writer.uint32(10).string(message.transactionId);
        }
        if (message.broadcastId !== "") {
            writer.uint32(18).string(message.broadcastId);
        }
        if (message.authnSessionId !== "") {
            writer.uint32(26).string(message.authnSessionId);
        }
        if (message.dwebData !== undefined) {
            exports.TivResponseDwebData.encode(message.dwebData, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTransactionDwebData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transactionId = reader.string();
                    break;
                case 2:
                    message.broadcastId = reader.string();
                    break;
                case 3:
                    message.authnSessionId = reader.string();
                    break;
                case 4:
                    message.dwebData = exports.TivResponseDwebData.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTransactionDwebData();
        message.transactionId = object.transactionId ?? "";
        message.broadcastId = object.broadcastId ?? "";
        message.authnSessionId = object.authnSessionId ?? "";
        message.dwebData =
            object.dwebData !== undefined && object.dwebData !== null
                ? exports.TivResponseDwebData.fromPartial(object.dwebData)
                : undefined;
        return message;
    },
};
function createBasePlatformRequestData() {
    return { data: undefined };
}
exports.PlatformRequestData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.data?.$case === "dwebData") {
            exports.TivRequestDwebData.encode(message.data.dwebData, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlatformRequestData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = {
                        $case: "dwebData",
                        dwebData: exports.TivRequestDwebData.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBasePlatformRequestData();
        if (object.data?.$case === "dwebData" &&
            object.data?.dwebData !== undefined &&
            object.data?.dwebData !== null) {
            message.data = {
                $case: "dwebData",
                dwebData: exports.TivRequestDwebData.fromPartial(object.data.dwebData),
            };
        }
        return message;
    },
};
function createBasePlatformResponseData() {
    return { data: undefined };
}
exports.PlatformResponseData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.data?.$case === "dwebData") {
            exports.TivResponseDwebData.encode(message.data.dwebData, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlatformResponseData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = {
                        $case: "dwebData",
                        dwebData: exports.TivResponseDwebData.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBasePlatformResponseData();
        if (object.data?.$case === "dwebData" &&
            object.data?.dwebData !== undefined &&
            object.data?.dwebData !== null) {
            message.data = {
                $case: "dwebData",
                dwebData: exports.TivResponseDwebData.fromPartial(object.data.dwebData),
            };
        }
        return message;
    },
};
function createBaseLogTivNotificationDisplayedRequest() {
    return {
        transactionId: "",
        broadcastId: "",
        clientPerceivedElapsedTimeMs: "0",
        channel: 0,
    };
}
exports.LogTivNotificationDisplayedRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.transactionId !== "") {
            writer.uint32(10).string(message.transactionId);
        }
        if (message.broadcastId !== "") {
            writer.uint32(18).string(message.broadcastId);
        }
        if (message.clientPerceivedElapsedTimeMs !== "0") {
            writer.uint32(24).int64(message.clientPerceivedElapsedTimeMs);
        }
        if (message.channel !== 0) {
            writer.uint32(32).int32(message.channel);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogTivNotificationDisplayedRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transactionId = reader.string();
                    break;
                case 2:
                    message.broadcastId = reader.string();
                    break;
                case 3:
                    message.clientPerceivedElapsedTimeMs = longToString(reader.int64());
                    break;
                case 4:
                    message.channel = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLogTivNotificationDisplayedRequest();
        message.transactionId = object.transactionId ?? "";
        message.broadcastId = object.broadcastId ?? "";
        message.clientPerceivedElapsedTimeMs =
            object.clientPerceivedElapsedTimeMs ?? "0";
        message.channel = object.channel ?? 0;
        return message;
    },
};
function createBaseLogTivNotificationDisplayedResponse() {
    return {};
}
exports.LogTivNotificationDisplayedResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogTivNotificationDisplayedResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseLogTivNotificationDisplayedResponse();
        return message;
    },
};
function createBaseLogTivNotificationReceivedRequest() {
    return { transactionId: "", broadcastId: "", channel: 0 };
}
exports.LogTivNotificationReceivedRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.transactionId !== "") {
            writer.uint32(10).string(message.transactionId);
        }
        if (message.broadcastId !== "") {
            writer.uint32(18).string(message.broadcastId);
        }
        if (message.channel !== 0) {
            writer.uint32(24).int32(message.channel);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogTivNotificationReceivedRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transactionId = reader.string();
                    break;
                case 2:
                    message.broadcastId = reader.string();
                    break;
                case 3:
                    message.channel = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLogTivNotificationReceivedRequest();
        message.transactionId = object.transactionId ?? "";
        message.broadcastId = object.broadcastId ?? "";
        message.channel = object.channel ?? 0;
        return message;
    },
};
function createBaseLogTivNotificationReceivedResponse() {
    return {};
}
exports.LogTivNotificationReceivedResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogTivNotificationReceivedResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseLogTivNotificationReceivedResponse();
        return message;
    },
};
class TivServiceClientImpl {
    rpc;
    constructor(rpc) {
        this.rpc = rpc;
        this.Tiv = this.Tiv.bind(this);
        this.InAppApproval = this.InAppApproval.bind(this);
        this.LogTivNotificationReceived =
            this.LogTivNotificationReceived.bind(this);
        this.LogTivNotificationDisplayed =
            this.LogTivNotificationDisplayed.bind(this);
        this.CreateTiv = this.CreateTiv.bind(this);
        this.RecreateTiv = this.RecreateTiv.bind(this);
        this.CreateTivNonce = this.CreateTivNonce.bind(this);
        this.LogTivSent = this.LogTivSent.bind(this);
        this.LogTivTimedOut = this.LogTivTimedOut.bind(this);
        this.GetTivByNonce = this.GetTivByNonce.bind(this);
        this.GetTivEligibility = this.GetTivEligibility.bind(this);
        this.GetTivStatus = this.GetTivStatus.bind(this);
        this.SetTivStatus = this.SetTivStatus.bind(this);
        this.VerifyTiv = this.VerifyTiv.bind(this);
    }
    Tiv(request, metadata) {
        return this.rpc.unary(exports.TivServiceTivDesc, exports.TivRequest.fromPartial(request), metadata);
    }
    InAppApproval(request, metadata) {
        return this.rpc.unary(exports.TivServiceInAppApprovalDesc, exports.InAppApprovalRequest.fromPartial(request), metadata);
    }
    LogTivNotificationReceived(request, metadata) {
        return this.rpc.unary(exports.TivServiceLogTivNotificationReceivedDesc, exports.LogTivNotificationReceivedRequest.fromPartial(request), metadata);
    }
    LogTivNotificationDisplayed(request, metadata) {
        return this.rpc.unary(exports.TivServiceLogTivNotificationDisplayedDesc, exports.LogTivNotificationDisplayedRequest.fromPartial(request), metadata);
    }
    CreateTiv(request, metadata) {
        return this.rpc.unary(exports.TivServiceCreateTivDesc, create_tiv_1.CreateTivRequest.fromPartial(request), metadata);
    }
    RecreateTiv(request, metadata) {
        return this.rpc.unary(exports.TivServiceRecreateTivDesc, recreate_tiv_1.RecreateTivRequest.fromPartial(request), metadata);
    }
    CreateTivNonce(request, metadata) {
        return this.rpc.unary(exports.TivServiceCreateTivNonceDesc, create_tiv_nonce_1.CreateTivNonceRequest.fromPartial(request), metadata);
    }
    LogTivSent(request, metadata) {
        return this.rpc.unary(exports.TivServiceLogTivSentDesc, log_tiv_sent_1.LogTivSentRequest.fromPartial(request), metadata);
    }
    LogTivTimedOut(request, metadata) {
        return this.rpc.unary(exports.TivServiceLogTivTimedOutDesc, log_tiv_timed_out_1.LogTivTimedOutRequest.fromPartial(request), metadata);
    }
    GetTivByNonce(request, metadata) {
        return this.rpc.unary(exports.TivServiceGetTivByNonceDesc, get_tiv_by_nonce_1.GetTivByNonceRequest.fromPartial(request), metadata);
    }
    GetTivEligibility(request, metadata) {
        return this.rpc.unary(exports.TivServiceGetTivEligibilityDesc, get_tiv_eligibility_1.GetTivEligibilityRequest.fromPartial(request), metadata);
    }
    GetTivStatus(request, metadata) {
        return this.rpc.unary(exports.TivServiceGetTivStatusDesc, get_tiv_status_1.GetTivStatusRequest.fromPartial(request), metadata);
    }
    SetTivStatus(request, metadata) {
        return this.rpc.unary(exports.TivServiceSetTivStatusDesc, set_tiv_status_1.SetTivStatusRequest.fromPartial(request), metadata);
    }
    VerifyTiv(request, metadata) {
        return this.rpc.unary(exports.TivServiceVerifyTivDesc, verify_tiv_1.VerifyTivRequest.fromPartial(request), metadata);
    }
}
exports.TivServiceClientImpl = TivServiceClientImpl;
exports.TivServiceDesc = {
    serviceName: "com.snapchat.auth.proto.tivs.TivService",
};
exports.TivServiceTivDesc = {
    methodName: "Tiv",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.TivRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...exports.TivResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.TivServiceInAppApprovalDesc = {
    methodName: "InAppApproval",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.InAppApprovalRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...exports.InAppApprovalResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.TivServiceLogTivNotificationReceivedDesc = {
    methodName: "LogTivNotificationReceived",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.LogTivNotificationReceivedRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...exports.LogTivNotificationReceivedResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.TivServiceLogTivNotificationDisplayedDesc = {
    methodName: "LogTivNotificationDisplayed",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exports.LogTivNotificationDisplayedRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...exports.LogTivNotificationDisplayedResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.TivServiceCreateTivDesc = {
    methodName: "CreateTiv",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return create_tiv_1.CreateTivRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...create_tiv_1.CreateTivResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.TivServiceRecreateTivDesc = {
    methodName: "RecreateTiv",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return recreate_tiv_1.RecreateTivRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...recreate_tiv_1.RecreateTivResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.TivServiceCreateTivNonceDesc = {
    methodName: "CreateTivNonce",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return create_tiv_nonce_1.CreateTivNonceRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...create_tiv_nonce_1.CreateTivNonceResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.TivServiceLogTivSentDesc = {
    methodName: "LogTivSent",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return log_tiv_sent_1.LogTivSentRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...log_tiv_sent_1.LogTivSentResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.TivServiceLogTivTimedOutDesc = {
    methodName: "LogTivTimedOut",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return log_tiv_timed_out_1.LogTivTimedOutRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...log_tiv_timed_out_1.LogTivTimedOutResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.TivServiceGetTivByNonceDesc = {
    methodName: "GetTivByNonce",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return get_tiv_by_nonce_1.GetTivByNonceRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...get_tiv_by_nonce_1.GetTivByNonceResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.TivServiceGetTivEligibilityDesc = {
    methodName: "GetTivEligibility",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return get_tiv_eligibility_1.GetTivEligibilityRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...get_tiv_eligibility_1.GetTivEligibilityResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.TivServiceGetTivStatusDesc = {
    methodName: "GetTivStatus",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return get_tiv_status_1.GetTivStatusRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...get_tiv_status_1.GetTivStatusResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.TivServiceSetTivStatusDesc = {
    methodName: "SetTivStatus",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return set_tiv_status_1.SetTivStatusRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...set_tiv_status_1.SetTivStatusResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.TivServiceVerifyTivDesc = {
    methodName: "VerifyTiv",
    service: exports.TivServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return verify_tiv_1.VerifyTivRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...verify_tiv_1.VerifyTivResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
class GrpcWebImpl {
    host;
    options;
    constructor(host, options) {
        this.host = host;
        this.options = options;
    }
    unary(methodDesc, _request, metadata) {
        const request = { ..._request, ...methodDesc.requestType };
        const maybeCombinedMetadata = metadata && this.options.metadata
            ? new browser_headers_1.BrowserHeaders({
                ...this.options?.metadata.headersMap,
                ...metadata?.headersMap,
            })
            : metadata || this.options.metadata;
        return new Promise((resolve, reject) => {
            grpc_web_1.grpc.unary(methodDesc, {
                request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function (response) {
                    if (response.status === grpc_web_1.grpc.Code.OK) {
                        resolve(response.message);
                    }
                    else {
                        const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
                        reject(err);
                    }
                },
            });
        });
    }
}
exports.GrpcWebImpl = GrpcWebImpl;
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
class GrpcWebError extends Error {
    code;
    metadata;
    constructor(message, code, metadata) {
        super(message);
        this.code = code;
        this.metadata = metadata;
    }
}
exports.GrpcWebError = GrpcWebError;
//# sourceMappingURL=tivs.js.map